'use client'
import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC } from 'react'

import { stylePanelSBData } from '@/lib/stylePanel'

import { PhnxGallarytext } from './Gallarytext'
import { GallarytextProps } from './Gallarytext'

interface GallarytextBlokProps {
  blok: {
    title: GallarytextProps['title']
    subtitle: GallarytextProps['subtitle']
    content: SbBlokData[]
    button: SbBlokData[]
    asset_one: any
    asset_two: any
    asset_three: any
    reverse?: GallarytextProps['reverse']
    mobileReverse?: GallarytextProps['mobileReverse']
    padding?: SbBlokData[]
    background?: SbBlokData[]
    colour?: SbBlokData[]
  } & SbBlokData
}

const Gallarytext: FC<GallarytextBlokProps> = ({ blok }) => {
  let stylePanel = stylePanelSBData(blok.colour, blok.background, blok.alignment, blok.padding)
  return (
    <div {...storyblokEditable(blok)}>
      <PhnxGallarytext
        title={blok.title}
        subtitle={blok.subtitle}
        content={
          blok.content &&
          blok.content.map((content: any) => (
            <StoryblokServerComponent key={content._uid} blok={content} />
          ))
        }
        asset_one={blok.asset_one && { url: blok.asset_one.filename, altText: blok.asset_one.alt }}
        asset_two={blok.asset_two && { url: blok.asset_two.filename, altText: blok.asset_two.alt }}
        asset_three={
          blok.asset_three && { url: blok.asset_three.filename, altText: blok.asset_three.alt }
        }
        button={
          blok.button &&
          blok.button.map((button: any) => (
            <StoryblokServerComponent key={button._uid} blok={button} />
          ))
        }
        reverse={blok.reverse}
        mobileReverse={blok.mobileReverse}
        textColor={stylePanel.textColor}
        backgroundColor={stylePanel.backgroundColor}
        padding={stylePanel.padding}
        alignment={stylePanel.alignment as 'left' | 'center' | 'right'}
      />
    </div>
  )
}

export default Gallarytext
